import React, { useContext, useState } from "react";
import Error from "../../components/Error";
import Loading from "../../components/Loading";
import { AuthContext } from "../../context/auth/AuthContext";
import { Request } from "../../api/eklok/Eklok.api";
import Success from "../../components/Success";

const EditEklokReleyContainer = ({
  reley,
  eklok,
  onRefresh = () => {},
  children,
}) => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const { token } = useContext(AuthContext);
  const [success, setSuccess] = useState(false);

  const onSubmit = (values, actions) => {
    setError(null);
    setLoading(true);
    const payload = setPayload(values);
    Request.updateReleStatus(token.access, payload)
      .then((data) => onSuccess(data, actions))
      .catch((error) => onFailure(error, actions));
  };

  const onSuccess = ({ data }, actions) => {
    Request.updateStatus(token.access, [eklok.id]).then(() => {
      setTimeout(() => {
        actions.setSubmitting(false);
        onRefresh();
        setLoading(false);
        setSuccess(true);
      }, 5000);
    });
  };

  const onFailure = (error, actions) => {
    setError(error);
    setLoading(false);
    actions.setSubmitting(false);
  };

  const onCloseSuccesPopup = () => {
    setSuccess(null);
  };

  const setPayload = (values) => {
    const rel = reley.find((r) => r.NAME === values.realy_name);
    return {
      eklok: eklok.id,
      percentage: values.percentage,
      module_addr: rel.MODULE_ADDR,
      rele_id: rel.RELE_ID,
    };
  };

  return (
    <>
      {error ? <Error message={error} onClose={() => setError(null)} /> : null}
      {loading ? <Loading /> : null}
      {success ? (
        <Success
          message="Reley data has been updated."
          onClose={() => onCloseSuccesPopup()}
        />
      ) : null}
      {children({ onSubmit, reley })}
    </>
  );
};

export default EditEklokReleyContainer;
